import "./i18n";
import { createRoot } from "react-dom/client";
import "@tabler/icons-webfont/dist/tabler-icons.min.css";
import "./index.css";
import App from "./App.tsx";
import { initRemixToTablerMapper } from "./lib/remixToTabler";
import { applyBrandTheme, loadBranding } from "./lib/theme";

initRemixToTablerMapper();
// Áp màu thương hiệu trước khi dựng giao diện để không thấy màu mặc định nhấp nháy.
applyBrandTheme();

/*
 * Nạp nhận diện thật rồi áp lại dải màu.
 *
 * Không `await`: giao diện phải hiện ngay với màu mặc định, nhận diện tới sau
 * vài trăm mili giây thì thay. Chờ mạng xong mới vẽ là màn hình trắng mỗi lần
 * mở ứng dụng trong kho, nơi wifi vốn chập chờn.
 */
void loadBranding();

createRoot(document.getElementById("root")!).render(<App />);

